import { render, staticRenderFns } from "./TalentService.vue?vue&type=template&id=a0069444&scoped=true"
import script from "./TalentService.vue?vue&type=script&lang=js"
export * from "./TalentService.vue?vue&type=script&lang=js"
import style0 from "./TalentService.vue?vue&type=style&index=0&id=a0069444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0069444",
  null
  
)

export default component.exports